/**
 * @file: InboxSettingsPanel.tsx
 *
 * Inbox notification settings in a panel — a thin `BottomPanel` wrapper around
 * `NotificationSettingsView`, with a centred header + close.
 */

import { BottomPanel } from '@euler/components/BottomPanel';
import { PaneHeader } from '@euler/components/PaneHeader';
import { FC, memo } from 'react';
import { View } from 'react-native';
import { NotificationSettingsView } from '../pages/settings';

export const InboxSettingsPanel: FC<{
  visible: boolean;
  onClose: () => void;
}> = memo(({ visible, onClose }) => (
  <BottomPanel visible={visible} onClose={onClose}>
    <View style={{ flex: 1 }}>
      <PaneHeader title="通知设置" align="center" onClose={onClose} />
      <NotificationSettingsView />
    </View>
  </BottomPanel>
));
